import { render, staticRenderFns } from "./AscDocMgmtTemplate.vue?vue&type=template&id=46f13c3b&"
import script from "./AscDocMgmtTemplate.vue?vue&type=script&lang=js&"
export * from "./AscDocMgmtTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports